export default function PHP_array_replace() {
  return (
    <div>
      <h1>PHP_array_replace</h1>
    </div>
  );
}
